import { TApplicationState } from '../../types/redux';

export function getNewbuldingFromTheBuilderLink(state: TApplicationState) {
  const {
    newbuilding: { newbuildingsFromTheBuilderLink },
  } = state;

  return newbuildingsFromTheBuilderLink;
}
